
import { Injectable } from '@angular/core';
import { Feedback } from './models/feedback.model';

@Injectable()
export class FeedbackService {

    constructor() { }

    submit(feedback: Feedback) {
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/feedback.service.ts